import useGTM from './useGTM';
import useInitialRender from './useInitialRender';

export { useGTM, useInitialRender };
